import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { VERIFY_EMAIL, VERIFY_EMAIL_SUCCESS, VERIFY_EMAIL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* VerifyEmail({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/email-verify`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: VERIFY_EMAIL_SUCCESS,
        payload: response?.data,
      });
    } else if(response.status === 202){
      cogoToast.success(`${response?.data?.message}`);
      
      yield put({
        type: VERIFY_EMAIL_SUCCESS,
        payload: response?.data,
      });
    }
     else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: VERIFY_EMAIL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VERIFY_EMAIL_ERROR, payload: error });
  }
}

export function* watchVerifyEmail() {
  yield takeEvery(VERIFY_EMAIL, VerifyEmail);
}

function* VerifyEmailSaga() {
  yield all([fork(watchVerifyEmail)]);
}

export default VerifyEmailSaga;
